import React, { FC } from "react";

export interface ErrorProps {
    size?: string;
    color?: string;
}

const defaultProps: ErrorProps = {
    color: "#e94949",
    size: "20px",
};


const style: React.CSSProperties = {
    height: "auto",
    verticalAlign: "middle",
    width: 20
};

export const Error: FC<ErrorProps> = (props: ErrorProps) => {
    const mergedProps: ErrorProps = { ...defaultProps, ...props };
    const { size, color } = mergedProps;
    const outsideProps: any = {};

    if (size) {
        outsideProps.width = size;
        outsideProps.height = size;
    }

    return (
        <span style={style}>
            <svg
                {...outsideProps}
                fill={color}
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                x="0px"
                y="0px"
                viewBox="0 0 96 96"
                style={{ enableBackground: "new 0 0 96 96" }}
            >
                <switch>
                    <foreignObject
                        requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"
                        x="0"
                        y="0"
                        width="1"
                        height="1"
                    />
                    <g>
                        <g>
                            <g>
                                <path
                                    style={{ fill: color }}
                                    d="M48,4C23.7,4,4,23.7,4,48s19.7,44,44,44s44-19.7,44-44S72.3,4,48,4z M48,84c-19.9,0-36-16.1-36-36s16.1-36,36-36      s36,16.1,36,36S67.9,84,48,84z"
                                />
                                <path
                                    style={{
                                        fill: color,
                                        stroke: color,
                                        strokeLinejoin: "round",
                                        strokeMiterlimit: 10,
                                        strokeWidth: 6
                                    }}
                                    d="M48,57c2.2,0,4-1.8,4-4V30c0-2.2-1.8-4-4-4s-4,1.8-4,4v23C44,55.2,45.8,57,48,57z"
                                />
                                <circle
                                    style={{
                                        fill: color,
                                        stroke: color,
                                        strokeLinejoin: "round",
                                        strokeMiterlimit: 10,
                                        strokeWidth: 4
                                    }}
                                    cx="48"
                                    cy="66.3"
                                    r="5"
                                />
                            </g>
                        </g>
                    </g>
                </switch>
            </svg>
        </span>
    );
};
